<template>

  <section class="article-wrapper">
    <div v-if="entry">
        <header class="page">
          <h2 class="title-header" v-html="entry.title"></h2>
        </header>
        <h4 v-if="entry.date">{{entry.date}}</h4>

        <main class="article-content" v-if="entry">

          <article class="article-image" v-if="entry.image">
            <img :src="entry.image" :alt="entry.title">
          </article>

          <article class="article-text typography-text">
            <div class="article-text__inner">
              <slot></slot>
            </div>
          </article>
          <no-ssr>
          <article class="article-slider" v-show="entrySlides.length > 0">
            <slider :autoplay="true" ref="slider">
              <image-slide v-for="slide in entrySlides" :key="slide.id" :image="slide.image"/>
            </slider>
          </article>
          </no-ssr>
          <br>
          <br>
          <content-video v-if="entry.video_link" :video="entry.video_link"></content-video>
        </main>
        <no-ssr>
        <footer class="more text-center" v-if="backUrl">
          <link-to :to="backUrl" class="btn medium solid--green"><span>{{backTitle}}</span></link-to>
        </footer>
        </no-ssr>
    </div>
    <main class="article-content" v-else>
      <article class="article-text typography-text">
        <div class="article-text__inner">
          <slot></slot>
        </div>
      </article>
    </main>
  </section>

</template>

<script>
  import ArticleVideo from "./ArticleVideo"
  //import Slider from '../shared/sliders/Slider'
  import ImageSlide from '../shared/sliders/ImageSlide'
  import ContentVideo from "../shared/content/ContentVideo";

  export default {
    props: {
      content: { type: Object },
      backUrl: { type: String, default: '' },
      backTitle: { type: String, default: 'Вернуться' },
    },
    data() {
      return {
        entry: this.content,
      };
    },
    computed: {
      entrySlides() {
        return this.entry ? this.entry.slides : [];
      },
    },
    watch: {
      content(newValue) {
        this.entry = newValue;
      },
    },
    components: {
      ArticleVideo,
    //  Slider,
      ImageSlide,
      ContentVideo
    },
  }
</script>


<style lang="scss" scoped>

  .article-wrapper {
    @media (max-width: 600px) {
      .page--top {
        padding-top: 25px;
      }
    }
  }

  .article-content {
    padding: 35px 0;
    @media (max-width: 600px) {
      padding: 0;
    }
  }

  .article-text {
    padding: 35px 0;
  }

  .article-video {
    padding: 35px 0;
    @media (max-width: 600px) {
      padding: 15px 0;
    }
    /deep/ video {
      background: black;
    }
  }

  .more {
    padding: 20px 0 80px;

  }

</style>



// WEBPACK FOOTER //
// components/articles/ArticlePage.vue